<template>

	<section id="XraySeries" @click="hideShowDidYouKnow">

		<div id="DidYouKnow">

			<div id="DYKToggle" class="dyk-toggle" :class="{show: showDidYouKnowToggle}">

				<img id="DYKToggleImage" :src="getDYK()" alt="Did you know?" v-on:click="showDidYouKnow = !showDidYouKnow" />

			</div>

			<div class="dyk-popup" :class="{show: showDidYouKnow}">

				<div class="dyk-popup__title">

					{{ $t('theFocusForZeiss') }}

				</div>

				<div class="dyk-popup__text" v-html="$t('thisIsWhyWeNot')">



				</div>

			</div>

		</div>

		<div id="Menu">

			<img src="/image/menu.png" usemap="#menumap" alt="Menu" />

			<map name="menumap">

				<area @click="onClick('systems', '/x-ray_series/systems')" shape="poly" coords="0,0,290,0,392,152,248,367" alt="Systems" />
				<area @click="onClick('software', '/x-ray_series/software')" shape="poly" coords="497,0,786,0,539,367,392,152" alt="Software" />
				<area @click="onClick('applications', '/applications')" shape="poly" coords="392,152,539,367,392,582,248,367" alt="Applications" />
				<area @click="onClick('services', 2)" shape="poly" coords="248,367,392,582,290,734,0,734" alt="Services" />
				<area @click="onClick('accessories', 3)" shape="poly" coords="539,367,786,734,496,734,392,582" alt="Accessories" />

			</map>


			<div class="menu-el menu-el--systems">

				<img src="../../assets/icons/systems_icon.png" />
				<br /><br />
				{{ $t('systems') }}

				<br />

				<div class="touch-effect" :class="{show: effect.systems}"></div>

			</div>

			<div class="menu-el menu-el--software">

				<img src="../../assets/icons/software_icon.png" />
				<br /><br />
				{{ $t('software') }}

				<br />

				<div class="touch-effect" :class="{show: effect.software}"></div>

			</div>

			<div class="menu-el menu-el--service">

				<img src="../../assets/icons/services_icon.png" />
				<br /><br />
				{{ $t('service') }}

				<br />

				<div class="touch-effect" :class="{show: effect.services}"></div>

			</div>

			<div class="menu-el menu-el--aapplications">

				<img src="/image/applications/applications.png" />
				<br /><br />
				{{ $t('applications') }}

				<br />

				<div class="touch-effect" :class="{show: effect.applications}"></div>

			</div>

			<div class="menu-el menu-el--accessories">

				<img src="../../assets/icons/accessories_icon.png" />
				<br /><br />
				{{ $t('accessories') }}

				<br />

				<div class="touch-effect" :class="{show: effect.accessories}"></div>

			</div>

		</div>


		<div v-if="popupShow" class="x-ray_series-popup">

			<div class="x-ray_series-popup__close">

				<img src="/image/close.png" alt="Close" @click="popupShow = false" />

			</div>

			<img :src="popupImage" alt="Popup" />

		</div>

	</section>

</template>

<script>

	import i18n from '@/plugins/i18n';

	export default {
		mounted () {
			setTimeout(() => this.showDidYouKnowToggle = true, 500);
		},
		data () {
			return {
				popupShow: false,
				popupImage: null,
				showDidYouKnowToggle: false,
				showDidYouKnow: false,
				effect: {
					systems: false,
					software: false,
					applications: false,
					services: false,
					accessories: false
				}
			};
		},
		methods: {
			showPopup (number) {
				this.popupImage = this.$t('/image/xrayseries/' + number + '.'+ i18n.locale +'.png');
				this.popupShow = true;
			},
			onClick (element, href) {
				for (let k of Object.keys(this.effect)) {
					this.effect[k] = false;
				}

				this.effect[element] = true;

				setTimeout(() => {
					if (typeof href === 'number') {
						this.showPopup(href);
					}
					else {
						this.$router.push(href);
					}
				}, 750);
			},
			hideShowDidYouKnow (evt) {
				if (evt.target.id === 'DYKToggle' || evt.target.id === 'DYKToggleImage') {
					return;
				}

				this.showDidYouKnow = false;
			},
			getDYK () {

				return `/image/dyk-lightestblue.${ i18n.locale }.png`;

			}
		}
	};

</script>
